/* eslint-disable no-underscore-dangle */
class SearchCache {
  constructor(RegionService) {
    this.defaults = {
      maxEntries: 10,
      searchKeyLength: 32
    };

    this.RegionService = RegionService;

    // Set up storage
    this.storage = window.localStorage || {};
    this.storage[this.cacheKey()] = this.storage[this.cacheKey()] || "[]";
    // Parse persisted data from store
    this.data = JSON.parse(this.storage[this.cacheKey()]);
  }

  // eslint-disable-next-line class-methods-use-this
  cacheKey() {
    return `searchCache_${
      this.RegionService.region ? this.RegionService.region : "noRegion"
    }`;
  }

  add(item) {
    // Add a search key
    // eslint-disable-next-line no-param-reassign
    item._searchKey =
      item._searchKey ||
      item.formatted_address.substring(0, this.searchKeyLength);

    // Search for existing match and splice
    // it out to avoid multiple adds
    const currentIndex = this.contains(item._searchKey);
    if (currentIndex >= 0) {
      this.data.splice(currentIndex, 1);
    }

    // Prepend to cache, to keep recently used at the
    // top, and let older one fall off the queue
    this.data.unshift(item);
    this.data.length = Math.min(this.data.length, this.defaults.maxEntries);

    return this.persist();
  }

  contains(key) {
    let index = -1;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < this.data.length; i++) {
      const item = this.data[i];
      if (item._searchKey === key) {
        index = i;
        break;
      }
    }
    return index;
  }

  search(term) {
    if (term == null) {
      throw new Error("No search term provided");
    }
    // eslint-disable-next-line no-param-reassign
    term = term.substring(0, this.defaults.searchKeyLength);
    // eslint-disable-next-line no-restricted-syntax
    for (const item of Array.from(this.data)) {
      if (item._searchKey.substr(0, term.length) === term) {
        return [item];
      }
    }
    return [];
  }

  clear() {
    this.data = [];
    return this.persist();
  }

  persist() {
    // console.log("storage", this.data);
    this.storage[this.cacheKey()] = JSON.stringify(this.data);
    return this;
  }
}

export default SearchCache;
